import { render, staticRenderFns } from "./RightSet.vue?vue&type=template&id=382ef953&scoped=true&"
import script from "./RightSet.vue?vue&type=script&lang=js&"
export * from "./RightSet.vue?vue&type=script&lang=js&"
import style0 from "./RightSet.vue?vue&type=style&index=0&id=382ef953&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382ef953",
  null
  
)

export default component.exports